import Box from "ds/components/Box";
import { Datum } from "ds/components/Charts/PieChart/types";
import IconEmphasized from "ds/components/IconEmphasized";
import TileContent from "ds/components/Tile/Content";
import Typography from "ds/components/Typography";
import Counter from "ds/components/Counter";
import { IconComponent } from "types/Icon";
import { IconEmphasizedColor } from "ds/components/IconEmphasized/types";
import { ChevronRight } from "components/icons/generated";
import Icon from "ds/components/Icon";
import TileDescription from "ds/components/Tile/Description";
import useTypedContext from "hooks/useTypedContext";
import { TileContext } from "ds/components/Tile/Context";

import styles from "./styles.module.css";

type DashboardResourcesChartTileContentProps = {
  data: Datum;
  logos: Record<string, { logo: IconComponent; iconColor: IconEmphasizedColor }>;
  hovered?: boolean;
  percentage: number;
};

const DashboardResourcesChartTileContent = ({
  data,
  logos,
  hovered,
  percentage,
}: DashboardResourcesChartTileContentProps) => {
  const vendor = logos[data.id];
  const { titleId } = useTypedContext(TileContext);

  if (!vendor) {
    return null;
  }

  return (
    <TileContent gap="small">
      <Box align="start" gap="medium" justify="between" fullWidth>
        <Box align="center" gap="medium" className={styles.tileContent} fullWidth>
          <IconEmphasized icon={vendor.logo} color={vendor.iconColor} />
          <Box direction="column" gap="small" align="start">
            <Box id={titleId} gap="medium" align="center">
              <Typography variant="p-t7" tag="span">
                {data.label}
              </Typography>
              <Counter
                variant={hovered ? "inversed" : "default"}
                size="small"
                count={`${percentage}%`}
              />
            </Box>
            <TileDescription>Total: {data.value}</TileDescription>
          </Box>
        </Box>
        <Box padding="small">
          <Icon src={ChevronRight} />
        </Box>
      </Box>
    </TileContent>
  );
};

export default DashboardResourcesChartTileContent;
